import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { Envelope } from '../stripeFeesQuery/types';
import { responseHandler } from '../utils';
import { AiPrices, AiPricesResponse } from './types';

/**
 * Globalny cennik AI. Backend zapisuje go w całości (formularz wysyła pełny stan),
 * bo przy scalaniu nie dałoby się usunąć modelu z cennika.
 */

export const AI_PRICES_QUERY_KEY = 'ai-prices';

export const useGetAiPrices = (): UseQueryResult<AiPricesResponse, AxiosError> => useQuery<
  AiPricesResponse,
  AxiosError
>({
  queryKey: [AI_PRICES_QUERY_KEY],
  retry: 0,
  queryFn: async () => {
    const response = await axiosInstance.get<Envelope<AiPricesResponse>>('/v3-getAiPrices');
    return responseHandler(response).data;
  },
});

export const useUpdateAiPrices = (): UseMutationResult<void, AxiosError, AiPrices> => useMutation<
  void,
  AxiosError,
  AiPrices
>({
  mutationFn: async (prices) => {
    const response = await axiosInstance.post('/v3-setAiPrices', prices);
    return responseHandler(response);
  },
});
